import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ReadOnlyFieldProps {
  id: string;
  label: string;
  value: string;
}

export function ReadOnlyField({ id, label, value }: ReadOnlyFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        value={value}
        readOnly
        className="h-10 cursor-default bg-muted/50 text-muted-foreground focus-visible:ring-0"
      />
    </div>
  );
}
